export enum BaggageEventTypes {
  SELECT_BAGGAGE = "SELECT_BAGGAGE",
  SKIP_BAGGAGE_SELECTION = "SKIP_BAGGAGE_SELECTION",
  CLEAR_BAGGAGE_ERROR = "CLEAR_BAGGAGE_ERROR",
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
}

export interface SelectBaggage {
  type: BaggageEventTypes.SELECT_BAGGAGE;
  passengerId: string;
  numCheckedBags: number;
}

export interface SkipBaggageSelection {
  type: BaggageEventTypes.SKIP_BAGGAGE_SELECTION;
}

export interface ClearBaggageError {
  type: BaggageEventTypes.CLEAR_BAGGAGE_ERROR;
}

export interface BaggageSelectionNextEvent {
  type: BaggageEventTypes.NEXT;
}

export interface BaggageSelectionPreviousEvent {
  type: BaggageEventTypes.PREVIOUS;
}

export type BaggageEvents =
  | SelectBaggage
  | SkipBaggageSelection
  | BaggageSelectionNextEvent
  | BaggageSelectionPreviousEvent;
